import React, {useState, useEffect} from 'react'

import classes from './GridTargets.module.css'
import Target from '../Target/Target';
import Draggable from '../Draggable/Draggable';
import clsx from 'clsx';

const GridTargets = ({dd, step, corrects}) => {
  let classNames = []



  if(dd.config) {
    try{
      let config = JSON.parse(dd.config)
      if(config.grid) {
        classNames.push(classes["grid" + config.grid])
      }
    }
    catch(err) { console.warn("err", err) }
  }

  return (
    <div className={clsx(classes.GridTargets, classNames)}>
      {dd.targets.map(t =>
      <Target
      target={t}
      key={t.ID}
      // setInfo_popup={setInfo_popup}
      >

        {(step === 0 || step === 1) &&
        dd.getSortedPlacedPropositionsByTarget(t)
        .map(i => (
          <Draggable
            key={i.ID}
            item={i}
            inTarget={t.ID}
            showCorrection={step === 1 || corrects.includes(i.ID)}
            disabled={step === 1 || corrects.includes(i.ID)}
          />
        ))}

        {step === 2 &&
        dd.getSortedPropositionsByTarget(t)
        .map(i => (
          <Draggable
            key={i.ID}
            item={i}
            inTarget={t.ID}
            showCorrection={true}
            disabled={true}
          />

        ))}
      </Target>)}
    </div>

  );
};

export default GridTargets;
